module.exports = __webpack_public_path__ + "img/ios.d53d6019.png";